module.exports = __webpack_public_path__ + "img/oculus_digi_wireframe.dac9e137.png";